import styled, { css } from 'styled-components';

import { FadeOutKeyframes } from 'DesignLibrary/keyframes';

interface FooterProps {
  isNextClicked: boolean;
}

export const FooterContainer = styled.footer<FooterProps>`
  padding: var(--sizing-md) 0;
  text-align: center;

  ${({ isNextClicked }) =>
    isNextClicked &&
    css`
      & {
        opacity: 1;
        animation: ${FadeOutKeyframes} 1s 0.25s forwards;
      }
    `}

  & > * + * {
    margin-top: var(--sizing-md);
  }

  .paragraph,
  p {
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 2rem;
  }

  a {
    color: var(--text-black);
    font-weight: 600;
    text-decoration: underline;

    img {
      margin: 0 0.25rem;
    }
  }
`;
